<template>
  <div class="theme-bg">
    <div style="text-align: center"><h3>Calendar Events</h3></div>
    <v-list-item-group
      v-model="settings"
      multiple
      style="max-height: 350px; overflow-y: scroll"
    >
      <template v-for="(task, index) in tasks">
        <v-list-item :key="index">
          <v-list-item-content class="text-color">
            <v-list-item-title>{{ task.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-item-group>
  </div>
</template>

<style scoped>
.theme-bg {
  background: #5351a0;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
export default {
  name: "Events",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    item: 1,
    settings: [],
    tasks: [],
    items: [
      { text: "Real-Time", icon: "mdi-clock", nav: "dashboard" },
      { text: "Audience", icon: "mdi-account", nav: "dashboard" },
      { text: "Help", icon: "mdi-account", nav: "help" },
      { text: "Logout", icon: "mdi-flag", nav: "login" },
    ],
  }),
  methods: {
    nav(path) {
      this.$router.push({ name: path });
    },
    loadClient() {
      let self = this;
      window.gapi.client.setApiKey("AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM");
      return window.gapi.client
        .load(
          "https://content.googleapis.com/discovery/v1/apis/calendar/v3/rest"
        )
        .then(
          function () {
            console.log("GAPI client loaded for API");
            // self.execute();
            self.listUpcomingEvents();
          },
          function (err) {
            console.error("Error loading GAPI client for API", err);
          }
        );
    },
    authenticate() {
      return window.gapi.auth2
        .getAuthInstance()
        .signIn({
          scope:
            "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.readonly",
        })
        .then(
          function () {
            console.log("Sign-in successful");
          },
          function (err) {
            console.error("Error signing in", err);
          }
        );
    },
    readOutLoud: function (msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
    },
    listUpcomingEvents() {
      let self = this;
      self.tasks = [];
      window.gapi.client.calendar.events
        .list({
          calendarId: "primary",
          timeMin: new Date("10/20/2019").toISOString(),
          timeMax: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: "startTime",
        })
        .then(function (response) {
          var events = response.result.items;
          console.log("Upcoming events:");
          self.readOutLoud(
            "you have total " +
              events.length +
              " Events, Do you want me to go through it?"
          );
          if (events.length > 0) {
            for (let i = 0; i < events.length; i++) {
              var event = events[i];
              var when = event.start.dateTime;
              if (!when) {
                when = event.start.date;
              }
              self.tasks.push({
                label: event.summary + " (" + when + ")",
                selected: true,
              });
              // console.log(event.summary + " (" + when + ")");
            }
          } else {
            console.log("No upcoming events found.");
          }
        });
    },
  },
  mounted() {
    // this.authenticate().then(this.loadClient);
    this.listUpcomingEvents();
  },
};
</script>
